import Input from "./Input";
// import RadioGroup from "./RadioGroup";
// import Select from "./Select";
// import DatePicker from "./DatePicker";
// import CheckBox from "./Checkbox";
// import Button from "./Button";
// import ActionButton from "./ActionButton";
// import InputAdornments from "./InputAdornments";

const Controls = {
    Input,
    // InputAdornments,
    // RadioGroup,
    // Select,
    // DatePicker,
    // CheckBox,
    // Button,
    // ActionButton
};

export default Controls;